import React from 'react';
import { LoginForm } from '@/loginng/views/LoginDialog';
import { loggedIn$ } from '@/account/subs';
import { useReframe } from 'nike-re-framejs';

export function LoginModule() {
    const { subscribe } = useReframe();
    const loggedIn = subscribe(loggedIn$);

    return !loggedIn ? <LoginForm registerInfo={false} loginOrigin="Login Module" /> : null;
}
